import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { flexEqualColumn } = stylingHelpers;

const baseStyles = () => css`
  ${flexEqualColumn()}
`;

const Grid = styled('div')(baseStyles);

export default Grid;
